

export const CreateWish = () => {
    return (<h1>Hello</h1>)
}